// @flow
import { handleActions } from 'redux-actions';

import {
  ADD_DOG,
  ADD_DOG_SUCCESS,
  ADD_DOG_FAILURE,
  ADD_VACCINATION,
  ADD_VACCINATION_SUCCESS,
  ADD_VACCINATION_FAILURE,
  ADD_VETERINARIAN,
  ADD_VETERINARIAN_SUCCESS,
  ADD_VETERINARIAN_FAILURE,
  ADD_VET_TO_DOG,
  ADD_VET_TO_DOG_SUCCESS,
  ADD_VET_TO_DOG_FAILURE,
  ADD_DOG_V4,
  ADD_DOG_V4_SUCCESS,
  ADD_DOG_V4_FAILURE,
  INIT_DOG,
  RESET_DOG,
  UPDATE_DOG,
  UPDATE_DOG_SUCCESS,
  UPDATE_DOG_FAILURE,
} from '../../actions/actionTypes';

const initialState = {
  id: null,
  name: '',
  age: '',
  breed: '',
  imageUrl: '',
  notes: '',
  sterile: null,
  vetId: '',
  vetEmail: '',
  vetName: '',
  vetPhone: '',
  vaccinations: [],
  isNew: false,
};

export const dog = handleActions(
  {
    [INIT_DOG]: (state, {
      payload: {
        id,
        breed,
        imageUrl,
        notes,
        name,
        sterile,
        veterinarians,
      },
    }) => (
      {
        ...state,
        id,
        breed,
        imageUrl,
        notes,
        name,
        sterile,
        veterinarians,
        isNew: false,
      }
    ),
    [RESET_DOG]: state => (
      {
        ...state,
        id: null,
        name: '',
        age: '',
        breed: '',
        imageUrl: '',
        notes: '',
        sterile: '',
        vetName: '',
        vetPhone: '',
        veterinarians: [],
      }
    ),
    [ADD_DOG]: state => (
      {
        ...state,
      }
    ),
    [ADD_DOG_SUCCESS]: (state, {
      payload: {
        dog: {
          id,
          age,
          breed = '',
          name,
          likes,
          vet_name: vetName,
          vet_phone: vetPhone,
          veterinarians,
        },
      },
    }) => (
      {
        ...state,
        id,
        age,
        breed,
        name,
        notes: likes,
        vetName,
        vetPhone,
        veterinarians,
        isNew: true,
      }
    ),
    [ADD_DOG_FAILURE]: state => (
      {
        ...state,
      }
    ),
    [ADD_DOG_V4]: state => (
      {
        ...state,
      }
    ),
    [ADD_DOG_V4_SUCCESS]: (state, {
      payload: {
        data: {
          id,
          age,
          breed,
          name,
          likes,
          veterinarians,
        },
      },
    }) => (
      {
        ...state,
        id,
        age,
        breed,
        name,
        likes,
        veterinarians,
        isNew: true,
      }
    ),
    [ADD_DOG_V4_FAILURE]: state => (
      {
        ...state,
      }
    ),
    [UPDATE_DOG]: state => (
      {
        ...state,
      }
    ),
    [ADD_VACCINATION]: state => (
      {
        ...state,
      }
    ),
    [ADD_VACCINATION_SUCCESS]: state => (
      {
        ...state,
      }
    ),
    [ADD_VACCINATION_FAILURE]: state => (
      {
        ...state,
      }
    ),
    [ADD_VETERINARIAN]: state => (
      {
        ...state,
      }
    ),
    [ADD_VETERINARIAN_SUCCESS]: (state, {
      payload: {
        data: {
          id,
          name,
          phone,
          address,
        },
      },
    }) => (
      {
        ...state,
        vetId: id,
        vetName: name,
        vetPhone: phone,
        vetAddress: address,
      }
    ),
    [ADD_VETERINARIAN_FAILURE]: state => (
      {
        ...state,
      }
    ),
    [ADD_VET_TO_DOG]: state => (
      {
        ...state,
      }
    ),
    [ADD_VET_TO_DOG_SUCCESS]: (state, {
      payload: {
        data: {
          veterinarians,
        },
      },
    }) => (
      {
        ...state,
        veterinarians,
      }
    ),
    [ADD_VET_TO_DOG_FAILURE]: state => (
      {
        ...state,
      }
    ),
    [UPDATE_DOG_SUCCESS]: (state, {
      payload: {
        dog: {
          id,
          age,
          breed,
          name,
          likes,
          sterile,
          vet_name: vetName,
          vet_phone: vetPhone,
          veterinarians,
        },
      },
    }) => (
      {
        ...state,
        id,
        age,
        breed,
        name,
        notes: likes,
        sterile,
        vetName,
        vetPhone,
        veterinarians,
      }
    ),
    [UPDATE_DOG_FAILURE]: state => (
      {
        ...state,
      }
    ),
  },
  initialState,
);
